import { getDateNow } from 'odfjell-date-time-utils/dateTimeUtils';
import useAppFeature from './useAppFeature';
import { AppFeatureEnum } from 'src/enums/appFeatureEnum';
import { useVesselStore } from 'src/context/VesselContext';
import { useStowagePlanStore } from 'src/context/StowagePlanContext';

export default () => {
    const { isFeatureEnabled } = useAppFeature();
    const { selectedVessel } = useVesselStore();
    const { masterPlanLoadState } = useStowagePlanStore();

    // Returns true while the master stowage plan fetch is in progress, indicating callers should
    // wait before loading rotation / event data. Unblocks as soon as the fetch reaches any terminal
    // state (loaded, not-found, error, idle) — including when no plan exists for the vessel.
    // Simple-mode vessels never need stowage plan context, so they are always unblocked.
    const checkLoadedStowageIntegration = (imoNumber: number): boolean =>
        isFeatureEnabled({ featureEnum: AppFeatureEnum.StowageIntegration, imoNumber, date: getDateNow() }) &&
        masterPlanLoadState === 'loading' &&
        !selectedVessel?.hasOrcaWebSimpleMode;

    return {
        checkLoadedStowageIntegration,
    };
};
